import UnlocksOverlay from "@pathwright/ui/src/components/overlay/UnlocksOverlay"
import { DROP_TYPE_PATH_ITEM } from "@pathwright/web/src/modules/path/constants"
import { DESIGN, LEARN } from "path/constants"
import PropTypes from "prop-types"
import React from "react"
import { Droppable } from "react-beautiful-dnd"
import { VelocityComponent, VelocityTransitionGroup } from "velocity-react"
import { withIsDragging } from "../../DragDropPathItems"
import PathStepCreate from "../../manage/step/PathStepCreate"
import PathStepContainer from "../step/PathStepContainer"
import "./PathGroupSteps.css"
import {
  groupGrowTransition,
  stepStaggerTransition
} from "./group-transition-config"

// Handles step list and transition animation

class PathGroupSteps extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (nextProps.pathListIsDragging) {
      return false
    }
    return true
  }

  render() {
    let skip
    const { group, startsDate } = this.props
    const { mode } = this.context
    // HACK ALERT: workaround for velocity error when expanding an empty lesson in TEACH mode.
    // In that case, treat the expanded lesson as if *not* expanded.
    const expanded =
      this.props.expanded && (mode === DESIGN || !!group.items.length)

    const isEditing = mode === DESIGN
    let stepCount = (group.items != null ? group.items.length : undefined) || 0
    if (isEditing) {
      stepCount += 1
    }

    const growTransition = groupGrowTransition(
      expanded,
      stepCount,
      (skip = isEditing)
    )
    const staggerTransition = stepStaggerTransition(
      stepCount,
      (skip = isEditing)
    )

    const steps = expanded
      ? group.items.map((item, index) => (
          <PathStepContainer
            item={item}
            mode={mode}
            index={index}
            isEditing={isEditing}
            key={`PathStep-${item.id}`}
          />
        ))
      : null

    return (
      <VelocityComponent {...Object.assign({}, growTransition)}>
        <div className="PathGroupSteps">
          <VelocityTransitionGroup {...Object.assign({}, staggerTransition)}>
            {expanded ? (
              mode === DESIGN ? (
                <Droppable
                  type={DROP_TYPE_PATH_ITEM}
                  droppableId={group.id + ""}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      className="PathGroupSteps--droppable"
                    >
                      {steps}
                      {provided.placeholder}
                      <PathStepCreate
                        key="PathStepAdd"
                        parent={group.id}
                        order={group.items.length + 1}
                      />
                    </div>
                  )}
                </Droppable>
              ) : (
                <>
                  {steps}
                  {mode === LEARN && (
                    <UnlocksOverlay starts={startsDate} overlay />
                  )}
                </>
              )
            ) : null}
          </VelocityTransitionGroup>
        </div>
      </VelocityComponent>
    )
  }
}

PathGroupSteps.displayName = "PathGroupSteps"

PathGroupSteps.contextTypes = { mode: PropTypes.number }

export default withIsDragging(PathGroupSteps)
